import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { requestStarted, requestFinished } from '~/stores/redux/common/loadingSlice';
import { handleThunkException } from '~/services/thunk.service';
import powerApi from '~/pages/Dashboard/AnalyticsBox/reports/Power/power.api';

export const fetchPowerApiOnInit = createAsyncThunk(
    'dashboard/power/fetchPowerApiOnInit',
    async (navigate, { dispatch, getState }) => {
        try {
            dispatch(requestStarted());
            const page = getState().dashboard.power.page;
            const res = await powerApi.getChunk(page);
            if (res) {
                dispatch(requestFinished());
                dispatch(fetchPowers(res.data));
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    },
);

export const fetchNextPowerApi = createAsyncThunk(
    'dashboard/power/fetchNextPowerApi',
    async (navigate, { dispatch, getState }) => {
        try {
            dispatch(incrementPage());
            const page = getState().dashboard.power.page;
            const res = await powerApi.getChunk(page);
            if (res) {
                dispatch(fetchPowers(res.data));
            }
        } catch (error) {
            handleThunkException(error, dispatch, navigate);
        }
    },
);

export const powerSlice = createSlice({
    name: 'dashboard/power',
    initialState: {
        apiDataSet: [],
        hasMore: true,
        totalPower: 0,
        page: 1,
    },
    reducers: {
        fetchPowers(state, { payload }) {
            return {
                ...state,
                apiDataSet: [...state.apiDataSet, ...payload.apiDataSet],
                totalPower: payload.totalPower,
            };
        },
        incrementPage(state) {
            state.page++;
        },
        setHasMore(state, { payload }) {
            state.hasMore = payload;
        },
    },
});

export const { incrementPage, setHasMore, fetchPowers } = powerSlice.actions;
